

export const MECHANIC_WEBHOOK_URL = 'https://webhooks.mechanic.dev/88cf2da9-e1e6-4541-bd01-4f47ea93c4c3';
// export const MECHANIC_WEBHOOK_URL = 'https://webhooks.mechanic.dev/f5a3d15c-28ad-4b84-910a-39b39e59e96c';

export const GOOGLE_LOGGER_URL = 'https://us-south1-willygoat-website.cloudfunctions.net/wg-quote-logger';
export const ZAPIER_WEBHOOK_URL = 'https://hooks.zapier.com/hooks/catch/10316243/bempk68/';

export const THANK_YOU_URL = 'https://willygoat.com/pages/thank-you-quote';

export const CUSTOMER_API_URL = '/api/customer';
// Set to true to also fire MECHANIC_WEBHOOK_URL_B in parallel during build-out
export const ENABLE_MECHANIC_WEBHOOK_B = false;





export const calcTypeOptions = [
  {name: "Area (Sq Ft)", value: "area"},
  {name: "Length / Width", value: "length_width"},
  {name: "Cubic Feet", value: "cubic_feet"},
  {name: "Cubic Yards", value: "cubic_yards"},
  {name: "Diameter (Ft)", value: "diameter"}
];
export const depthOptions = [
  {name: "1\" Depth", value: 1},
  {name: "2\" Depth (for landscaping)", value: 2},
  {name: "3\" Depth/Up to 5' Fall Height", value: 3},
  {name: "4\" Depth/Up to 7' Fall Height", value: 4},
  {name: "5\" Depth/Up to 10' Fall Height", value: 5},
  {name: "6\" Depth/Up to 12' Fall Height", value: 6},
  {name: "7\" Depth/Up to 14' Fall Height", value: 7},
  {name: "8\" Depth", value: 8},
  // {name: "9\" Depth", value: 9},
  {name: "10\" Depth", value: 10},
  // {name: "11\" Depth", value: 11},
  {name: "12\" Depth", value: 12},
];

export const PI = 3.1415927;

export const fallHeightOptions = [4, 5, 6, 7, 8, 9, 10, 11, 12];
export const BORDER_LENGTH = 52;


export const mulchConfig = {
  mulch_weight: 50,
  ground_smart_weight: 2000,
  mulch_volume: 25,
  mulch_volume_per_pound: 0.625,
  mulch_product_id: 6740121485409,
  mulch_variant_id: 39822862450785,
  ground_smart_variant_id: 32428362563681,
  ground_smart_product_id: 3935174033505,
  mulch_product_url: "https://willygoat.com/collections/rubber-mulch/products/loose-fill-rubber-mulch",
  ground_smart_product_url: "https://willygoat.com/products/playground-rubber-mulch",
  ground_smart_handle: "playground-rubber-mulch",
  default_depth_index: 2,
}

export const ewfConfig = {
  ewf_product_id: 3935114657889,
  ewf_materials_id: 3935114657889,
  ewf_labor_id: 3935114657889,
  ewf_mats_perc: 0.75,
  ewf_url: "https://willygoat.com/products/engineered-wood-fiber-playground-surfacing",
  ewf_handle: "engineered-wood-fiber-playground-surfacing",
  ewf_min_price: 18.7,
  ewf_max_price: 45.95,
  ewf_margin: 1.35,
  ewf_title: "Engineered Wood Fiber",
  ewf_compaction_factor: {
    e_3_ft: 0.012,
    e_4_ft: 0.016,
    e_5_ft: 0.021,
    e_6_ft: 0.025,
    e_7_ft: 0.029,
    e_8_ft: 0.033,
    e_9_ft: 0.037,
    e_10_ft: 0.041,
    e_11_ft: 0.045,
    e_12_ft: 0.05,
  },
  // ewf_min_with_freight: 36,
  // ewf_max_with_freight: 96,
}

export const MINIMUM_SQFT = 500;

export const surfacingConfig = {
  p_margin: 1.3454,
  surfacing_product_id: 7167726583905,
  surfacing_materials_id: 7249370153057,
  surfacing_labor_id: 7251199787105,
  surfacing_mats_perc: 0.69,
  surfacing_url: "https://willygoat.com/products/pour-in-place-playground-surfacing-fully-installed",
  surfacing_handle: "pour-in-place-playground-surfacing-fully-installed",
  surfacing_tiers: {
    p_4_ft: 21.82,
    p_5_ft: 23.30,
    p_6_ft: 23.30,
    p_7_ft: 25.15,
    p_8_ft: 25.15,
    p_9_ft: 29.09,
    p_10_ft: 29.09,
    p_11_ft: 29.09,
    p_12_ft: 29.90,
  },
  custom_pip_materials_variant_id: 41959573094497,
  custom_pip_labor_variant_id: 41963888246881,
}

export const turfConfig = {
  t_margin: 1.25,
  turf_product_id: 7431093813345,
  turf_materials_id: 7437775044705,
  turf_labor_id: 7437774061665,
  turf_mats_perc: 0.75,
  turf_url: "https://willygoat.com/products/turf-playground-surfacing",
  turf_handle: "turf-playground-surfacing",
  turf_custom_materials_variant_id: 42696112996449,
  turf_custom_labor_variant_id: 42696103788641,
  /**
   * Turf cost-per-sqft schedule.
   * Intentionally stored under an obscure key, but still readable.
   * Shape:
   *  t_pri_config: [
   *    [maxFallHeight, [[minSqft, costPerSqft], ...]] // minSqft descending; last row is catch-all
   *  ]
   */
  t_pri_config: {
    t_5_ft:  [[3000, 17],    [2000, 18],    [1500, 19],    [1250, 20.5],  [1000, 21.5],  [750, 22.75], [0, 24]],
    t_10_ft: [[3000, 18.25], [2000, 19.25], [1500, 20.25], [1250, 21.75], [1000, 22.75], [750, 24],    [0, 25.25]],
  },
}


export const installConfig = {
  mimimum_installation_cost: 2950, 
  mimimum_installation_price: 4086,
  freestanding_margin: 1.385,
  mulch_equipment_fees: 1486,
  ground_smart_base_cost: 95,
  loose_fill_base_cost: 2.5,
  install_product_id: 6745043730529,
  custom_install_variant_id: 42235809497185,
  state_tiers: {
    tier_0: {
      states: ['AL', 'AR', 'CT', 'DE', 'FL', 'GA', 'IA', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD', 'MI', 'MN', 'MO', 'NC', 'NJ', 'NY', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'TN', 'TX', 'VA', 'WA', 'WI', 'WV'],
      multiple: 1
    },
    tier_1: {
      states: ['AZ', 'ID', 'ME', 'MS', 'ND', 'NE', 'NH', 'NM', 'NV', 'SD'],
      multiple: 1.1
    },
    tier_2: {
      states: ['CO', 'MT', 'UT', 'VT', 'WY'],
      multiple: 1.25
    },
    tier_3: {
      states: ['CA'],
      multiple: 1.25,
      additional_fee: 2950
    }
  },
}


export const submissionMessages = [
  [
    `Swinging through our inventory to grab the best deals...`,
    `No "kid"-ding around, we’re pulling your info together fast.`,
    `Grazing for the best prices... hold tight!`,
    `Your quote is getting ready to slide.`
  ],
  [
    `Taking a quick juice-box break while we calculate your total...`,
    `Herding up your quote details...`,
    `Calling dibs on the best discounts for you...`,
    `Pinky-promise, your quote is coming right up.`
  ],
  [
    `Herding up your quote details...`,
    `Chewing through the data right now.`,
    `Grazing for the best prices... hold tight!`,
    `No "kid"-ding around, we're pulling your info together fast.`
  ]
];